import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.split";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import border from '@/components/border/borderType';
import fileTable from '@/components/border/fileTable';
import warn from '@/components/border/warn';
import analysisRadio from '@/components/env-bigData/analysisRadio';
import calendar from '@/components/env-bigData/calendar';
import calendarPie from '@/components/env-bigData/calendarPie';
import monthSelect from '@/components/date/bmonthSelect';
import dial from '@/components/env-bigData/watch';
import { queryDateList, queryWastWaterDateList, queryRealWaterDateList, queryWaterCurveAnalysis, queryScreenWarn, querWaterReport, queryStandardTreeList, queryWaterStand, standardMonth, queryWastDateList } from '@/api/api';
import moment from 'moment';
import { getAction } from '@/api/manage';
export default {
  data: function data() {
    return {
      showRadio: true,
      showDial: false,
      standState: false,
      showToast: false,
      showPie: true,
      stand: [],
      showDetail: false,
      dateList: [],
      siteId: 0,
      analysisType: 11,
      start: '',
      end: '',
      waterWarnList: [],
      defaultValue: 1,
      quantum: new Date().getFullYear() + '-' + (new Date().getMonth() + 1),
      colors: ['#ccc'],
      standardList: [],
      showIt: false,
      showAnalysis: false,
      standText: '',
      standLabel: '',
      defaultValues: 0,
      radioIndex: '',
      radioStatu: true,
      radioOptions: []
    };
  },
  components: {
    border: border,
    fileTable: fileTable,
    analysisRadio: analysisRadio,
    warn: warn,
    calendar: calendar,
    monthSelect: monthSelect,
    dial: dial,
    calendarPie: calendarPie
  },
  props: {
    selectId: {
      default: '0',
      type: String
    },
    selectType: {
      default: '0',
      type: String
    },
    siteDetail: {
      type: Object
    }
  },
  created: function created() {},
  watch: {
    selectId: function selectId(val) {
      var _this = this;

      console.log('siteDetail', this.siteDetail);
      this.showRadio = false;
      this.$nextTick(function () {
        _this.showRadio = true;
        _this.analysisType = 11;
        _this.defaultValues = 1;

        _this.$nextTick(function () {
          // this.getStandard(val)
          _this.getDateList(val);

          _this.getPolutionData(val); // this.getWarn(this.defaultValues, val, this.selectType)

        });
      });
    }
  },
  mounted: function mounted() {},
  methods: {
    // 点击水质日历对应日期出现弹框
    ontoGet: function ontoGet(value, year) {
      var _this2 = this;

      console.log(value, year);
      this.resetSetItem('siteId', this.selectId);
      this.resetSetLocalItem('treeSt', '21'); // window.localStorage.setItem('treeSt','21')

      this.resetSetItem('siteType', '21');
      setTimeout(function () {
        _this2.$router.push({
          path: '/online/cn2061',
          query: {
            year: year,
            path: '/ds/index',
            selectId: _this2.selectId
          }
        });
      }, 500); // if (value) this.toastText = value
      // else this.toastText = '暂无数据'
      // this.showToast = true
      // setTimeout(() => {
      // 	this.showToast = false
      // }, 2000)
    },
    // 点击水质日历查看饼图
    ontoSelect: function ontoSelect() {
      this.showDetail = true;
      this.showIt = true;

      if (this.showDetail) {// this.$refs.pie.initBarChart('2020-11')
      }
    },
    // 获取水质日历对应颜色对应数值的格式化
    getStand: function getStand(data) {
      if (data) {
        for (var i = 0; i < this.standardList.length; i++) {
          if (this.standardList[i].data.title == data.title) {
            return i + 1;
          }
        }
      } else {
        return 0;
      }
    },
    // 获取水质标准数据
    getwaterStand: function getwaterStand(id) {
      var _this3 = this;

      queryWaterStand({
        scope: 1,
        scopeId: id
      }).then(function (res) {
        if (res.success && res.result) {
          var color = [];
          var title = [];
          var a = [];
          var date = [Object.keys(res.result)[2], Object.keys(res.result)[0], Object.keys(res.result)[1]];
          a.push(_this3.getStand(res.result[date[0]] ? res.result[date[0]].currentStandard : ''));
          a.push(_this3.getStand(res.result[date[1]] ? res.result[date[1]].currentStandard : ''));
          a.push(_this3.getStand(res.result[date[2]] ? res.result[date[2]].currentStandard : ''));

          if (res.result[date[0]] != null && res.result[date[0]].currentStandard != null) {
            color.push(res.result[date[0]].currentStandard.color);
            title.push(res.result[date[0]].currentStandard.title);
          } else {
            color.push('');
            title.push('');
          }

          if (res.result[date[1]] != null && res.result[date[1]].currentStandard != null) {
            color.push(res.result[date[1]].currentStandard.color);
            title.push(res.result[date[1]].currentStandard.title);
          } else {
            color.push('');
            title.push('');
          }

          if (res.result[date[2]] && res.result[date[2]].currentStandard != null) {
            color.push(res.result[date[2]].currentStandard.color);
            title.push(res.result[date[2]].currentStandard.title);
          } else {
            color.push('');
            title.push('');
          }

          _this3.showDial = false;

          _this3.$nextTick(function () {
            _this3.showDial = true;

            _this3.$nextTick(function () {
              _this3.$refs.dials.initBarChart(title, color, date, a, _this3.standardList.length);
            });
          }); // let arr = []
          // let color = []
          // if(res.result['同比标准']){
          // 	color.push()
          // }
          // color.push()

        } else {
          var _date = new Date();

          var year1 = _date.getFullYear() - 1 + '-' + (_date.getMonth() + 1) + '-' + _date.getDate();

          var year2 = _date.getFullYear() + '-' + (_date.getMonth() + 1) + '-' + _date.getDate();

          var year3 = _date.getMonth() != 0 ? _date.getFullYear() + '-' + _date.getMonth() + '-' + _date.getDate() : _date.getFullYear() - 1 + '-12' + '-' + _date.getDate();
          _this3.showDial = false;

          _this3.$nextTick(function () {
            _this3.showDial = true;

            _this3.$nextTick(function () {
              _this3.$refs.dials.initBarChart(['', '', ''], ['#ccc', '#ccc', '#ccc'], [year1, year2, year3], [0, 0, 0], 6);
            });
          });
        }
      });
    },
    // 获取国标数据
    getStandard: function getStandard(id) {
      var _this4 = this;

      queryStandardTreeList().then(function (res) {
        if (res.success) {
          // res.result[0].children[0].children.forEach((item, index) => {
          //   item.data.title = item.data.title.replace('类', '')
          //   item.data.show = true
          //   return item
          // })
          _this4.colors = ['#ccc'];
          var arr = [];
          var stand = [];
          res.result.forEach(function (item, index) {
            if (item.label == '国家标准') {
              if (item.children != null) {
                item.children.forEach(function (item1, index1) {
                  if (item1.key == 'K1_3') {
                    arr = item1.children;
                    stand = JSON.parse(JSON.stringify(item1.children));
                    return;
                  }
                });
              }
            }
          });
          var colors = [];
          var title = [];
          arr.forEach(function (item, index) {
            // item.data.title = item.data.title.replace('类', '')
            colors.push(item.data.color);
            title.push(item.data.title); // return item
          });
          _this4.title = title;
          stand.forEach(function (item, index) {
            item.data.title = item.data.title.replace('类', '');
            return item;
          });
          _this4.colors = [].concat(colors, _toConsumableArray(_this4.colors));
          _this4.standardList = arr;
          _this4.stand = stand;

          _this4.getReport(id);

          _this4.getwaterStand(id); // this.getReport(id)

        }
      });
    },
    // 水质日历日期选择
    monthChange: function monthChange(value) {
      this.quantum = value;

      if (this.siteId) {
        this.getReport(this.siteId);
      }
    },
    // 水质日历查看饼图中的日期选择
    changemMonth: function changemMonth(value) {
      var _this5 = this;

      this.showPie = false;
      this.$nextTick(function () {
        _this5.showPie = true;

        if (_this5.siteId) {
          _this5.getStandmonth(_this5.siteId, value);
        }
      });
    },
    // 获取各个月份的饼图数据
    getStandmonth: function getStandmonth(id, quantum) {
      var _this6 = this;

      standardMonth({
        scopeId: id,
        quantum: quantum
      }).then(function (res) {
        if (res.success) {
          var label = [];
          var a = [];
          var color = [];
          var arr = [];
          var data = [];
          res.result.standard.forEach(function (item, index) {
            label.push(item.title);
          });
          var monthArr = Object.keys(res.result.monthStandard);
          monthArr.forEach(function (item, index) {
            // if(res.result.monthStandard[item])
            if (!(JSON.stringify(res.result.monthStandard[item]) == '{}')) {
              // let arr = Object.keys(res.result.monthStandard[item])
              var arrs = [];
              var obj = {}; // for (let j = 0; j < arr.length; j++) {

              for (var i = 0; i < res.result.standard.length; i++) {
                obj.name = res.result.standard[i].title;
                obj.color = res.result.standard[i].color;

                if (res.result.monthStandard[item][res.result.standard[i].title]) {
                  obj.value = res.result.monthStandard[item][res.result.standard[i].title].num;
                  color.push(res.result.standard[i].color);
                } else {
                  obj.value = 0;
                  color.push('');
                }

                data.push(obj);
                obj = {}; // }
              }

              arr.push(data);
              data = [];
              color = [];
            } else {
              var _obj = {};

              for (var _i = 0; _i < res.result.standard.length; _i++) {
                color.push('');
                _obj.name = res.result.standard[_i].title;
                _obj.color = res.result.standard[_i].color;
                _obj.value = 0;
                data.push(_obj);
                _obj = {};
              }

              arr.push(data);
              data = [];
            }
          }); // setTimeout(() => {

          _this6.$refs.pie.initBarChart(quantum, label, arr); // }, 200)

        }
      });
    },
    // 通过年月获取该月天数
    getDaysInOneMonth: function getDaysInOneMonth(year, month) {
      month = parseInt(month, 10);
      var d = new Date(year, month, 0);
      return d.getDate();
    },
    // 获取水质日历数据
    getReport: function getReport(id) {
      var _this7 = this;

      querWaterReport({
        scopeId: id,
        scope: 1,
        st: 21,
        type: 3,
        quantum: this.quantum // id,
        // type: 3,
        // quantum: this.quantum,

      }).then(function (res) {
        if (res.success) {
          var a = [];

          var num = _this7.getDaysInOneMonth(_this7.quantum.split('-')[0], _this7.quantum.split('-')[1]);

          res.result.records.forEach(function (item, index) {
            if (index < num) {
              if (item.attrs.currentStandard) {
                for (var i = 0; i < _this7.standardList.length; i++) {
                  if (_this7.standardList[i].data.title == item.attrs.currentStandard.title) {
                    a.push(i);
                    break;
                  }
                } // switch (item.currentStandard.title) {
                //   case 'Ⅰ类':
                //     a.push(0)
                //     break
                //   case 'Ⅱ类':
                //     a.push(1)
                //     break
                //   case 'Ⅲ类':
                //     a.push(2)
                //     break
                //   case 'Ⅳ类':
                //     a.push(3)
                //     break
                //   case 'Ⅴ类':
                //     a.push(4)
                //     break
                //   case '劣V类':
                //     a.push(5)
                //     break
                // }

              } else {
                a.push(_this7.standardList.length);
              }
            }
          });

          _this7.$refs.calendar.initBarChart(_this7.quantum.split('-')[0], _this7.quantum.split('-')[1], a, _this7.colors, _this7.title);
        }
      });
    },
    // 控制轮播数据
    scroll: function scroll() {
      var _this8 = this;

      setTimeout(function () {
        if (_this8.waterWarnList.length > 6) {
          _this8.waterWarnList.push(_this8.waterWarnList[0]); // 将数组的第一个元素添加到数组的


          _this8.waterWarnList.shift(); //删除数组的第一个元素

        }
      }, 500);
      setTimeout(function () {
        if (_this8.dateList.length > 11) {
          _this8.dateList.push(_this8.dateList[0]); // 将数组的第一个元素添加到数组的


          _this8.dateList.shift(); //删除数组的第一个元素

        }
      }, 500);
    },
    // 站点警报的tab切换
    changetadios: function changetadios(e) {
      this.defaultValues = e;
      if (e == 0) this.radioIndex = '';else this.radioIndex = e;
      this.getWarn(this.radioIndex, this.selectId, this.selectType); // this.getWarn(this.radioIndex,this.selectType)
    },
    //获取预警内容
    getWarn: function getWarn(category, siteId, st) {
      var _this9 = this;

      console.log(category, siteId, st);
      var params = {
        category: category,
        scope: 1,
        scopeId: siteId,
        warnStatus: 1 // current: 1,
        // size: 20

      }; // 污水站点

      queryScreenWarn(params).then(function (res) {
        if (res.success && res.result.length > 0) {
          res.result.forEach(function (item, index) {
            switch (item.category) {
              case '1':
                item.category_dictText = '数据报警';
                break;

              case '2':
                item.category_dictText = '设备报警';
                break;

              case '4':
                item.category_dictText = '离线预警';
                break;
            }
          });
          _this9.waterWarnList = res.result;
        } else {
          _this9.waterWarnList = [];
        }
      });
    },
    // 获取日期
    getDay: function getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() - 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码

      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      var hour = today.getHours();
      var minute = today.getMinutes();
      var second = today.getSeconds();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + '-' + tMonth + '-' + tDate; // return tYear + '-' + tMonth + '-' + tDate+' '+hour+':'+minute+':'+second
    },
    // 日期格式化
    doHandleMonth: function doHandleMonth(month) {
      var m = month;

      if (month.toString().length == 1) {
        m = '0' + month;
      }

      return m;
    },
    // 获取水质趋势
    getPolutionData: function getPolutionData(id, start) {
      var _this10 = this;

      if (id) this.siteId = id;
      if (!start) start = this.getDay(0);
      this.radioOptions = [];
      var selectedFactor = ['dx', 'dy', 'dz', 'sl011', 'sl005'];
      queryWaterCurveAnalysis({
        scopeId: this.siteId,
        type: 1,
        stime: start,
        etime: this.getDay(0),
        dataType: this.analysisType
      }, this.selectType).then(function (res) {
        if (res.success) {
          if (res.result.records.length > 0) {
            var time = [];
            var labelData = [];
            var selectedObj = {};
            res.result.records.forEach(function (data) {
              time.push(data.dataTime);
            });
            var popArr = [];
            res.result.query.factors.forEach(function (ele) {
              if (selectedFactor.findIndex(function (item) {
                return item === ele.code;
              }) > -1) {
                selectedObj["".concat(ele.title, "(").concat(ele.unitName, ")")] = true;
              } else {
                selectedObj["".concat(ele.title, "(").concat(ele.unitName, ")")] = false;
              }

              labelData.push("".concat(ele.title, "(").concat(ele.unitName, ")"));
              var arr = [];
              res.result.records.forEach(function (item) {
                var obj = {
                  name: item.dataTime,
                  value: item.factor && item.factor.hasOwnProperty(ele.code) && item.factor[ele.code].hasOwnProperty('value') ? item.factor[ele.code].value : ''
                };
                arr.push(obj);
              });
              popArr.push({
                data: arr,
                title: "".concat(ele.title, "(").concat(ele.unitName, ")")
              }); // ele.time = time
              // ele.labelData = [`${ele.title}(${ele.unitName})`]
              // this.radioOptions.push(ele)
            });
            console.log('selectedObj', selectedObj);
            _this10.showAnalysis = false;

            _this10.$nextTick(function () {
              _this10.showAnalysis = true;

              _this10.$nextTick(function () {
                _this10.$refs.pollution.initBarChart(popArr, time, labelData, selectedObj, 7);
              });
            });
          } else {
            var _labelData = [];
            var _selectedObj = {};
            res.result.query.factors.forEach(function (item, index) {
              if (selectedFactor.findIndex(function (item) {
                return item === ele.code;
              }) > -1) {
                _selectedObj["".concat(ele.title, "(").concat(ele.unitName, ")")] = true;
              } else {
                _selectedObj["".concat(ele.title, "(").concat(ele.unitName, ")")] = false;
              }

              _labelData.push("".concat(ele.title, "(").concat(ele.unitName, ")"));
            });
            _this10.showAnalysis = false;

            _this10.$nextTick(function () {
              _this10.showAnalysis = true;

              _this10.$nextTick(function () {
                _this10.$refs.pollution.initBarChart([], [], _labelData, _selectedObj, 7);
              });
            });
          }
        }
      });
    },
    // 获取实时水质数据
    getDateList: function getDateList(id) {
      var _this11 = this;

      var param = this.siteDetail.category == 2 ? {
        st: this.selectType,
        stime: moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss'),
        etime: moment(moment().format('YYYY-MM-DD') + ' 23:59:59').format('YYYY-MM-DD HH:mm:ss'),
        order: 'desc',
        scopeId: id,
        scope: 1,
        searchCount: true
      } : {
        st: this.selectType,
        order: 'desc',
        scopeId: id,
        scope: 1,
        searchCount: true
      };
      var url = this.siteDetail.category == 2 ? "online/st".concat(this.selectType, "/cn2061/") : "/online/st".concat(this.selectType, "/realtime/");
      this.dateList = [];
      getAction(url, param).then(function (res) {
        if (res.success && res.result.records.length > 0) {
          var state;
          res.result.query.factors.forEach(function (item, index) {
            item.value = res.result.records[0].factor[item.code].hasOwnProperty('value') ? res.result.records[0].factor[item.code].value : '';

            if (res.result.records[0].factor[item.code].standard) {
              item.standTitle = res.result.records[0].factor[item.code].standard.title;
              item.standColor = res.result.records[0].factor[item.code].standard.color;
            } else {
              item.standTitle = '';
              item.standColor = '';
            }

            switch (res.result.records[0].factor[item.code].status) {
              case 0:
                state = '无数据';
                break;

              case 1:
                state = '正常';
                break;

              case 2:
                state = '低报';
                break;

              case 3:
                state = '高报';
                break;

              case 4:
                state = '数据异常';
                break;
            }

            item.state = state;
            item.render = _this11.renderCol(item.code, '', res.result.records[0]);
            state = '';
            return item;
          });
          _this11.standState = '';
          _this11.standLabel = '不达标';

          if (res.result.records[0].hasOwnProperty('attrs')) {
            if (res.result.records[0].attrs.hasOwnProperty('upStandard')) {
              _this11.standState = res.result.records[0].attrs.upStandard;
              _this11.standLabel = res.result.records[0].attrs.upStandard ? '达标' : '不达标';
            }

            _this11.standText = res.result.records[0].attrs.hasOwnProperty('currentStandard') ? res.result.records[0].attrs.currentStandard.hasOwnProperty('title') ? res.result.records[0].attrs.currentStandard.title : '' : '';
          }

          _this11.dateList = res.result.query.factors;
        } else {
          res.result.query.factors.forEach(function (item, index) {
            item.value = '';
            item.standColor = '';
            item.standTitle = '';
            item.state = '';
            item.render = '';
            return item;
          });
          _this11.standState = false;
          _this11.standText = '';
          _this11.standLabel = '不达标';
          _this11.dateList = res.result.query.factors;
        }
      });
    },
    // 渲染列
    renderCol: function renderCol(code, text, record) {
      var data = record.factor[code] || {
        value: ''
      };

      if (data.status == '2') {
        return '<span  style=\'color:green;padding-left:15px\' class=\'redText\' title=\'原始数据：  ' + (data.raw != null ? data.raw : '一') + '\'>' + (data.value != null ? data.value : '一') + '<div class=\'iconfont icon-xiangxiajiantou\' style=\'float:right;color:green\' ></div></span>';
      } else if (data.status == '3') {
        return '<span style=\'color:red;padding-left:15px\' title=\'原始数据：' + (data.raw != null ? data.raw : '一') + '\'>' + (data.value != null ? data.value : '一') + '<div class=\'iconfont icon-iconset0414\' style=\'float:right;color:red\' ></div></span>';
      } else {
        return '<span title=\'原始数据：' + (data.raw != null ? data.raw : '一') + '\'>' + (data.value != null ? data.value : '一') + '</span>';
      }
    },
    // 水质趋势的tab切换
    changeRadio: function changeRadio(e) {
      var time;

      switch (e.target.value) {
        // analysisType用于控制查询的水质趋势的类型  11:小时数据  12:日数据
        case 1:
          this.analysisType = 11;
          this.getPolutionData('', this.getDay(0));
          break;

        case 2:
          this.analysisType = 12;
          this.getPolutionData('', this.getDay(7));
          break;

        case 3:
          this.analysisType = 12;
          this.getPolutionData('', this.getDay(30));
          break;
      }
    }
  }
};